import React, { HTMLAttributes } from 'react'

import { VariantProps, cva } from 'class-variance-authority'
import clsx from 'clsx'

const spinnerVariants = cva('align-middle animate-spin spinner-border inline-block rounded-full', {
  defaultVariants: {
    color: 'primary'
  },
  variants: {
    color: {
      black: 'border-t-black',
      primary: 'border-t-primary-default',
      white: 'border-t-white'
    }
  }
})
export type SpinnerProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * If present, a label will render only on screen readers for accessibility
   */
  label?: string
  className?: string
} & VariantProps<typeof spinnerVariants>

/**
 * Spinners provide a visual cue that an action is either processing, awaiting a course of change or a result.
 * This spinner will inherit the current border color, and will by default be sized at 1rem but can be overridden with w- and h- classes.
 *
 */
export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(({ className, color, label }, ref) => (
  <div
    aria-label='Loading'
    className={clsx('h-5 w-5 border-2', spinnerVariants({ color }), className)}
    ref={ref}
    role='status'
  >
    <div className='sr-only'>{label ?? 'Loading'}</div>
  </div>
))

Spinner.displayName = 'Spinner'
